import script from "./DiscussionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscussionPage.vue?vue&type=script&setup=true&lang=js"

import "./DiscussionPage.vue?vue&type=style&index=0&id=26821e0a&lang=css"

const __exports__ = script;

export default __exports__